import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { OrderVolumeProfileActionPayload } from './actions';
import { OrderVolumeProfileWidgetState } from './OrderVolumeProfileWidgetState';
import { buildOrderVolumeProfileConfigSlice } from './configuration/configSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildOrderVolumeProfileComponentSlice } from './component/componentSlice';

const { reducer: configReducer } = buildOrderVolumeProfileConfigSlice();
const { reducer: componentReducer } = buildOrderVolumeProfileComponentSlice();

const widgetStateReducer = combineReducers<OrderVolumeProfileWidgetState>({
    config: configReducer,
    component: componentReducer,
});

export const orderVolumeProfileWidgetsReducer = createWidgetsReducer<
    OrderVolumeProfileWidgetState,
    OrderVolumeProfileActionPayload
>(WidgetType.ORDER_VOLUME_PROFILE, widgetStateReducer);
